import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftFromLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-arrow-left-from-line-icon lucide-arrow-left-from-line", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9 6-6 6 6 6" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12h14" }), /* @__PURE__ */ React.createElement("path", { d: "M21 19V5" }));
const ForwardRef = forwardRef(SvgArrowLeftFromLine);
export default ForwardRef;
